/**
 * 접속자 언어에 맞춰 문서 메타(제목/설명/OG/Twitter/og:image)를 런타임 갱신.
 * 정적 호스팅이라 크롤러별 언어 협상은 불가하지만, 라이브 문서와 JS 렌더링 프리뷰 도구에는
 * 로케일에 맞는 메타/공유 카드(og-image-<locale>.png)가 반영된다. 정적 index.html의
 * 기본 메타(en)는 JS를 실행하지 않는 크롤러의 폴백으로 남는다.
 */
import { t, LOCALE } from './i18n';
import { ogImageUrl } from '../config/site';

function setMeta(selector: string, value: string): void {
  const el = document.querySelector(selector);
  if (el) el.setAttribute('content', value);
}

export function applyLocalizedMeta(): void {
  document.documentElement.lang = LOCALE;
  // 브라우저 탭에는 짧은 로케일 타이틀만(예: "사무실 책상 뿌시기" / "Desk Smash").
  // SEO/공유 메타(og·twitter)와 정적 <title>은 브랜드 포함 풀 타이틀(pageTitle)을 유지.
  document.title = t('tabTitle');

  const title = t('pageTitle');
  const desc = t('metaDesc');
  const image = ogImageUrl();

  setMeta('meta[name="description"]', desc);
  setMeta('meta[property="og:title"]', title);
  setMeta('meta[property="og:description"]', desc);
  setMeta('meta[property="og:image"]', image);
  setMeta('meta[name="twitter:title"]', title);
  setMeta('meta[name="twitter:description"]', desc);
  setMeta('meta[name="twitter:image"]', image);
}
